import {ReactNode} from "react";
import {FieldError, FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";

import {IRange} from "@pg-design/range-module";

import {IDefaultForYouFormValues} from "../../hooks/use_default_for_you_values";
import {useForYouFormResolvers} from "../../hooks/use_for_you_form_resolvers";
import {ForYouFormValuesType, IForYouForm} from "../../types/IForYouForm";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";

interface IProps {
    children: (
        submitHandler: SubmitHandlerType,
        onChange?: (name: string, values: ForYouFormValuesType) => void,
        onSubmitError?: (name: string, error: FieldError) => void
    ) => ReactNode;
    names: string[];
    defaultValues: IDefaultForYouFormValues;
}

export const ForYouFormsProvider = (props: IProps) => {
    const defaultValues = props.names.reduce(
        (acc, name) => {
            // @ts-ignore
            return {...acc, [name]: props.defaultValues[name]};
        },
        {} as {[key: string]: string | number | IRange<number>}
    );

    const resolvers = useForYouFormResolvers(props.names);

    const formMethods = useForm<IForYouForm>({
        defaultValues,
        resolver: yupResolver(resolvers)
    });

    const onValueChange = (name: string, values: ForYouFormValuesType) => {
        if (Object.keys(defaultValues).includes(name)) {
            formMethods.setValue(name as keyof IForYouForm, values);
        }
    };

    const onSubmitError = (name: string, error: FieldError) => {
        formMethods.setError(name as keyof IForYouForm, error);
    };

    return <FormProvider {...formMethods}>{props.children(formMethods.handleSubmit, onValueChange, onSubmitError)}</FormProvider>;
};
import {ReactNode} from "react";
import {FieldError, FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";

import {IRange} from "@pg-design/range-module";

import {IDefaultForYouFormValues} from "../../hooks/use_default_for_you_values";
import {useForYouFormResolvers} from "../../hooks/use_for_you_form_resolvers";
import {ForYouFormValuesType, IForYouForm} from "../../types/IForYouForm";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";

interface IProps {
    children: (
        submitHandler: SubmitHandlerType,
        onChange?: (name: string, values: ForYouFormValuesType) => void,
        onSubmitError?: (name: string, error: FieldError) => void
    ) => ReactNode;
    names: string[];
    defaultValues: IDefaultForYouFormValues;
}

export const ForYouFormsProvider = (props: IProps) => {
    const defaultValues = props.names.reduce(
        (acc, name) => {
            // @ts-ignore
            return {...acc, [name]: props.defaultValues[name]};
        },
        {} as {[key: string]: string | number | IRange<number>}
    );

    const resolvers = useForYouFormResolvers(props.names);

    const formMethods = useForm<IForYouForm>({
        defaultValues,
        resolver: yupResolver(resolvers)
    });

    const onValueChange = (name: string, values: ForYouFormValuesType) => {
        if (Object.keys(defaultValues).includes(name)) {
            formMethods.setValue(name as keyof IForYouForm, values);
        }
    };

    const onSubmitError = (name: string, error: FieldError) => {
        formMethods.setError(name as keyof IForYouForm, error);
    };

    return <FormProvider {...formMethods}>{props.children(formMethods.handleSubmit, onValueChange, onSubmitError)}</FormProvider>;
};
